module.exports = __webpack_public_path__ + "img/map-marker-alt-trusted.d01b4fc4.svg";